import { SET_VEHICLE_INFO } from '../actions/types';

export default function vehicleInfo(state = {}, action) {
	switch (action.type) {
		case SET_VEHICLE_INFO:
			return action.payload;
		default:
			return state;
	}
}
